const userRoleOptions = [
  'Broker',
  'Builder',
  'Engine Manufacturer',
  'Family Office',
  'Legal, Financial, Insurance',
  'Luxury Industry',
  'Marina',
  'Marine Ancillary Services',
  'Naval Architect',
  "Owner's Representative",
  'Project Manager',
  'Refit & Maintenance',
  'Superyacht Enthusiast',
  'Superyacht Owner',
  'Supplier',
  'Technology Manufacturer',
  'Yacht Management Services',
  'Other'
].map(e => [e, e]);

export default userRoleOptions;
